/* MKB 2026 — Kit builder, part 2 of 5 (see mkb-builder-1.js). */
(function (K) {
  'use strict';
  var ORD = K.ORD, COLORS = K.COLORS, KITE_PTS = K.KITE_PTS, BOARD_PTS = K.BOARD_PTS, WAIST_TXT = K.WAIST_TXT, STRAP_TXT = K.STRAP_TXT, GUIDES = K.GUIDES, COPY = K.COPY, LABEL = K.LABEL, ROLE = K.ROLE;
  var esc = K.esc, uniq = K.uniq, first = K.first, clone = K.clone, num = K.num, ordOf = K.ordOf, interp = K.interp, sized = K.sized, swatch = K.swatch, round1 = K.round1, article = K.article;

  /* ---------- builder ---------- */
  function Builder(root) {
    var dataEl = root.querySelector('[data-kb-data]');
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var self = this;
    this.root = root; this.D = D; this.uid = root.id || 'kb';
    this.cur = D.currency || 'USD';
    this.P = {};
    (D.products || []).forEach(function (p) { if (p && p.h && !self.P[p.h]) self.P[p.h] = self.prep(p); });
    this.notes = {};
    String(D.notes || '').split(/\r?\n/).forEach(function (line) {
      var parts = line.split('|').map(function (s) { return s.trim(); });
      if (parts.length >= 2 && parts[0]) self.notes[parts[0]] = parts.length >= 3 ? { name: parts[1], note: parts[2] } : { note: parts[1] };
    });
    this.hookInc = D.hookIncluded || [];
    this.pkgs = (D.packages || []).map(function (k) {
      ['kites', 'bars', 'harnesses', 'hooks', 'boards', 'straps', 'pumps', 'addons', 'lessons'].forEach(function (f) {
        k[f] = uniq((k[f] || []).filter(function (h) { return !!self.P[h]; }));
      });
      k.kiteCount = Math.max(1, parseInt(k.kiteCount, 10) || 1);
      k.barCount = Math.max(1, parseInt(k.barCount, 10) || 1);
      return k;
    }).filter(function (k) { return k.kites.length; });
    if (!this.pkgs.length) return;
    this.rider = { w: null, wu: 'lb', x: null, xu: 'in', s: null, su: 'us' };
    try { var saved = JSON.parse(sessionStorage.getItem('mkbKbRider') || 'null'); if (saved) this.rider = saved; } catch (e) {}
    this.open = {}; this.flag = null; this.focusKey = null; this.busy = false; this.err = '';
    this.els = {
      stage: root.querySelector('[data-kb-stage]'), steps: root.querySelector('[data-kb-steps]'),
      sum: root.querySelector('[data-kb-summary]'), bar: root.querySelector('[data-kb-bar]')
    };
    this.els.steps.innerHTML = '<div data-kb-pkg></div><div data-kb-rider></div><div data-kb-dyn></div>';
    this.els.pkg = this.els.steps.querySelector('[data-kb-pkg]');
    this.els.rider = this.els.steps.querySelector('[data-kb-rider]');
    this.els.dyn = this.els.steps.querySelector('[data-kb-dyn]');

    var start = null, qp = null;
    try { qp = new URLSearchParams(location.search).get('package'); } catch (e) {}
    start = first(this.pkgs, function (k) { return (D.current && k.product === D.current) || (qp && (k.product === qp || k.id === qp)); });
    if (!start && this.pkgs.length === 1) start = this.pkgs[0];

    root.addEventListener('click', function (e) { self.onClick(e); });
    root.addEventListener('input', function (e) { self.onInput(e); });
    this.buildStage();
    this.renderPkg();
    if (start) this.choosePkg(start.id, true); else this.renderAll();
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { ticking = false; self.onScroll(); });
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      this.sumIO = new IntersectionObserver(function (en) {
        en.forEach(function (x) { self.sumVisible = x.isIntersecting; self.syncBar(); });
      }, { rootMargin: '0px 0px -10% 0px' });
    }
    root.classList.add('is-ready');
  }

  Builder.prototype.prep = function (p) {
    p.opts = p.opts || [];
    p.v = p.v || [];
    p.meta = p.opts.map(function (name, i) {
      var vals = uniq(p.v.map(function (v) { return v.o[i]; }));
      var kind = /colou?r/i.test(name) ? 'color' : /size/i.test(name) ? 'size' : 'other';
      var kiteVal = first(vals, function (x) { return /kite/i.test(x); });
      var hidden = vals.length <= 1 || (kind === 'other' && !!kiteVal);
      return { name: name, i: i, vals: vals, kind: kind, hidden: hidden, fixed: vals.length <= 1 ? vals[0] : kiteVal };
    });
    var size = first(p.meta, function (m) { return m.kind === 'size' && !m.hidden; });
    if (!size) size = first(p.meta, function (m) { return m.kind === 'other' && !m.hidden; });
    var color = first(p.meta, function (m) { return m.kind === 'color' && !m.hidden; });
    p.sizeI = size ? size.i : -1;
    p.colorI = color ? color.i : -1;
    var av = p.v.filter(function (v) { return v.a; });
    p.avail = av.length > 0;
    var pool = av.length ? av : p.v;
    p.min = pool.length ? Math.min.apply(null, pool.map(function (v) { return v.p; })) : 0;
    p.max = pool.length ? Math.max.apply(null, pool.map(function (v) { return v.p; })) : 0;
    var t = String(p.t || '').replace(/\s+/g, ' ').replace(/\(\s+/g, '(').replace(/\s+\)/g, ')').trim();
    var m = t.split(/\s+-\s+/);
    p.brand = m.length > 1 ? m[0] : '';
    p.name = m.length > 1 ? m.slice(1).join(' - ') : t;
    return p;
  };

  Builder.prototype.title = function (p) { var n = this.notes[p.h]; return (n && n.name) || p.name; };
  Builder.prototype.note = function (p) { var n = this.notes[p.h]; return (n && n.note) || ''; };
  Builder.prototype.money = function (c, short) {
    var n = c / 100, whole = Math.round(c) % 100 === 0, d = (short && whole) ? 0 : 2;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: this.cur, minimumFractionDigits: d, maximumFractionDigits: d }).format(n); }
    catch (e) { return '$' + n.toFixed(d); }
  };

  /* ---------- variants ---------- */
  Builder.prototype.optVal = function (p, sel, m) { return m.hidden ? m.fixed : sel[m.i]; };
  Builder.prototype.variant = function (p, sel) {
    var self = this;
    return first(p.v, function (v) {
      return p.meta.every(function (m) { var s = self.optVal(p, sel, m); return s != null && v.o[m.i] === s; });
    });
  };
  /* any available variant with option i = val that agrees with the other chosen options */
  Builder.prototype.availWith = function (p, sel, i, val) {
    var self = this;
    return p.v.some(function (v) {
      if (!v.a || v.o[i] !== val) return false;
      return p.meta.every(function (m) { if (m.i === i) return true; var s = self.optVal(p, sel, m); return s == null || v.o[m.i] === s; });
    });
  };
  /* any available variant with option i = val (other visible options free) */
  Builder.prototype.existsAny = function (p, i, val) {
    return p.v.some(function (v) {
      if (!v.a || v.o[i] !== val) return false;
      return p.meta.every(function (m) { return !m.hidden || m.i === i || v.o[m.i] === m.fixed; });
    });
  };
  Builder.prototype.priceFor = function (p, sel, i, val) {
    var t = clone(sel); t[i] = val;
    var v = this.variant(p, t);
    if (v) return v.p;
    var self = this, ps = p.v.filter(function (x) { return x.o[i] === val && p.meta.every(function (m) { return !m.hidden || x.o[m.i] === m.fixed; }); }).map(function (x) { return x.p; });
    return ps.length ? Math.min.apply(null, ps) : p.min;
  };
  Builder.prototype.minGiven = function (p, sel) {
    var self = this;
    var ps = p.v.filter(function (v) {
      return v.a && p.meta.every(function (m) { var s = self.optVal(p, sel, m); return s == null || v.o[m.i] === s; });
    }).map(function (v) { return v.p; });
    return ps.length ? Math.min.apply(null, ps) : p.min;
  };

  /* ---------- package → slots ---------- */
  Builder.prototype.makeSlots = function (k) {
    var S = [], i, roles = k.kiteCount > 1 ? ['mid', 'high', 'light'] : ['single'];
    for (i = 0; i < k.kiteCount; i++) S.push({ key: 'kite' + i, kind: 'kite', role: roles[i] || 'mid', idx: i, list: k.kites });
    for (i = 0; i < k.barCount; i++) S.push({ key: 'bar' + i, kind: 'bar', idx: i, list: k.bars, follows: i === 0 ? 'kite0' : 'kite' + (k.kiteCount - 1) });
    S.push({ key: 'harness', kind: 'harness', list: k.harnesses });
    S.push({ key: 'hook', kind: 'hook', list: k.hooks, parent: 'harness' });
    S.push({ key: 'board', kind: 'board', list: k.boards });
    S.push({ key: 'straps', kind: 'straps', list: k.straps });
    S.push({ key: 'pump', kind: 'pump', list: k.pumps });
    return S;
  };
  Builder.prototype.slot = function (key) { return first(this.slots || [], function (s) { return s.key === key; }); };
  Builder.prototype.needHook = function () {
    var h = this.slot('hook'), hs = this.st.harness, hsl = this.slot('harness');
    if (!h || !h.list.length || !hsl || !hsl.list.length || !hs || hs.skip || !hs.h) return false;
    return this.hookInc.indexOf(hs.h) < 0;
  };
  /* true = shown, 'na' = no product online (board), false = hidden */
  Builder.prototype.isOn = function (sl) {
    if (sl.kind === 'hook') return this.needHook();
    if (!sl.list.length) return sl.kind === 'board' ? 'na' : false;
    return true;
  };

  Builder.prototype.choosePkg = function (id, silent) {
    var k = first(this.pkgs, function (x) { return x.id === id; });
    if (!k) return;
    var self = this;
    this.pkg = k;
    this.slots = this.makeSlots(k);
    this.st = {}; this.ex = {};
    this.slots.forEach(function (sl) {
      self.st[sl.key] = { h: null, sel: {}, man: {}, skip: false, fit: null };
      var h = first(sl.list, function (x) { return self.P[x].avail; }) || sl.list[0];
      if (h) self.setProduct(sl, h);
    });
    k.addons.concat(k.lessons).forEach(function (h) { self.ex[h] = { on: false, sel: {}, man: {} }; self.initSel(self.P[h], self.ex[h]); });
    this.autoAll();
    this.focusKey = 'kite0';
    this.renderAll();
    if (!silent) this.syncBar();
  };

  Builder.prototype.initSel = function (p, s) {
    var self = this;
    p.meta.forEach(function (m) {
      if (m.hidden || m.i === p.sizeI) return;
      s.sel[m.i] = first(m.vals, function (val) { return self.existsAny(p, m.i, val); }) || m.vals[0];
    });
  };
  Builder.prototype.setProduct = function (sl, h) {
    var s = this.st[sl.key], p = this.P[h];
    s.h = h; s.sel = {}; s.man = {}; s.fit = null;
    this.initSel(p, s);
    this.autoSize(sl);
  };

  /* ---------- rider + recommendations ---------- */
  Builder.prototype.lb = function () { var r = this.rider; if (!r.w) return null; return r.wu === 'kg' ? r.w * 2.20462 : r.w; };
  Builder.prototype.waist = function () { var r = this.rider; if (!r.x) return null; return r.xu === 'cm' ? r.x / 2.54 : r.x; };
  Builder.prototype.shoe = function () { var r = this.rider; if (!r.s) return null; return r.su === 'eu' ? r.s - 33 : r.s; };
  Builder.prototype.weightTxt = function () { var r = this.rider; return r.w ? (round1(r.w) + (r.wu === 'kg' ? ' kg' : ' lbs')) : ''; };

  Builder.prototype.rec = function (sl) {
    var lb, w, sh, s, p, v, n;
    switch (sl.kind) {
      case 'kite':
        lb = this.lb(); if (lb == null) return null;
        return { ideal: interp(KITE_PTS[sl.role] || KITE_PTS.single, lb), parse: num };
      case 'bar':
        s = this.st[sl.follows]; if (!s || s.skip || !s.h) return null;
        p = this.P[s.h]; v = p.sizeI >= 0 ? s.sel[p.sizeI] : null; if (v == null) return null;
        n = num(v); if (isNaN(n)) return null;
        return { ideal: n <= 9 ? 38 : n <= 12 ? 45 : 50, parse: num, kite: n };
      case 'board':
        lb = this.lb(); if (lb == null) return null;
        return { ideal: interp(BOARD_PTS, lb), parse: num };
      case 'harness':
        w = this.waist(); if (w == null) return null;
        return { ideal: w < 26 ? 0 : w < 29.5 ? 1 : w < 33 ? 2 : w < 35 ? 3 : w < 37.5 ? 4 : w < 41 ? 5 : 6, parse: ordOf };
      case 'hook':
        s = this.st.harness; if (!s || !s.h) return null;
        p = this.P[s.h]; v = p.sizeI >= 0 ? s.sel[p.sizeI] : null; if (v == null) return null;
        var o = ordOf(v); if (isNaN(o)) return null;
        w = this.waist();
        var mm = o <= 1 ? 24 : o < 2.5 ? (w != null && w < 31 ? 24 : 28) : o < 3.5 ? 28 : o < 4.5 ? (w != null && w < 36.5 ? 28 : 32) : 32;
        return { ideal: mm, parse: function (x) { var q = num(x); return q > 100 ? q / 10 : q; }, harness: v };
      case 'straps':
        sh = this.shoe(); if (sh == null) return null;
        return { ideal: sh <= 6.5 ? 2 : sh <= 8.5 ? 3 : sh <= 10.5 ? 4 : 5, parse: ordOf };
    }
    return null;
  };

  Builder.prototype.autoSize = function (sl) {
    var s = this.st[sl.key];
    if (!s || !s.h) return;
    var p = this.P[s.h];
    if (p.sizeI < 0) return;
    var r = this.rec(sl);
    s.fit = null; s.ideal = null;
    if (!r) {
      /* only one size in stock? take it */
      var only = p.meta[p.sizeI].vals.filter(function (val) { return this.existsAny(p, p.sizeI, val); }, this);
      if (only.length === 1 && !s.man.size) s.sel[p.sizeI] = only[0];
      return;
    }
    var self = this, i = p.sizeI, best = null, bestD = Infinity, lock = p.colorI >= 0 && s.man.color;
    p.meta[i].vals.forEach(function (val) {
      var n = r.parse(val); if (isNaN(n)) return;
      var ok = lock ? self.availWith(p, s.sel, i, val) : self.existsAny(p, i, val);
      if (!ok) return;
      var d = Math.abs(n - r.ideal) - (n >= r.ideal ? 0.001 : 0);
      if (d < bestD) { bestD = d; best = val; }
    });
    s.fit = best;
    /* the ideal size whether or not it is in stock, to say so when it is sold out */
    var idealVal = null, idealD = Infinity;
    p.meta[i].vals.forEach(function (val) {
      var n = r.parse(val); if (isNaN(n)) return;
      var d = Math.abs(n - r.ideal) - (n >= r.ideal ? 0.001 : 0);
      if (d < idealD) { idealD = d; idealVal = val; }
    });
    s.ideal = idealVal;
    if (s.man.size) return;
    if (best == null) { delete s.sel[i]; return; }
    s.sel[i] = best;
    this.fixColor(p, s);
  };
  /* the chosen size is not in stock in this color: move to a color that has it */
  Builder.prototype.fixColor = function (p, s) {
    if (p.colorI < 0) return;
    var v = this.variant(p, s.sel);
    if (v && v.a) return;
    var self = this, ci = p.colorI;
    var c = first(p.meta[ci].vals, function (val) { var t = clone(s.sel); t[ci] = val; var x = self.variant(p, t); return x && x.a; });
    if (c) s.sel[ci] = c;
  };
  Builder.prototype.autoAll = function () {
    var self = this;
    (this.slots || []).forEach(function (sl) { if (self.st[sl.key] && !self.st[sl.key].skip) self.autoSize(sl); });
  };
  K.Builder = Builder;
})(window.MKBKB);